import overviewTemplateUrl from "emun.cust/details/cust-details.overview.htm";
import profileTemplateUrl from "emun.cust/details/cust-details.profile.htm";
import shipToTemplateUrl from "emun.cust/details/cust-details.ship-to.htm";
import paymentMethodsTemplateUrl from "emun.cust/details/cust-details.payment-methods.htm";
import vendorInfoTemplateUrl from "emun.cust/details/cust-details.vendor-info.htm";
import ordersTemplateUrl from "emun.cust/details/cust-details.orders.htm";
import invoicesTemplateUrl from "emun.cust/details/cust-details.invoices.htm";
import documentsTemplateUrl from "emun.cust/details/cust-details.documents.htm";
import paymentHistoryTemplateUrl from "emun.cust/details/cust-details.payment-history.htm";
import itemHistoryTemplateUrl from "emun.cust/details/cust-details.item-history.htm";
import purchaseHistoryTemplateUrl from "emun.cust/details/cust-details.purchase-history.htm";
import topSellersTemplateUrl from "emun.cust/details/cust-details.top-sellers.htm";
import paymentsTemplateUrl from "emun.cust/details/cust-details.payments.htm";
import changeLogTemplateUrl from "emun.cust/details/cust-details.change-log.htm";
import formsTemplateUrl from "emun.cust/details/cust-details.forms.htm";
import usersTemplateUrl from "emun.cust/details/cust-details.users.htm";
import creditmemosTemplateUrl from "emun.cust/details/cust-details.creditmemos.htm";
import contactsTemplateUrl from "emun.cust/details/cust-details.contacts.htm";
import activitiesTemplateUrl from "emun.cust/details/cust-details.activities.htm";
import notesTemplateUrl from "emun.cust/details/cust-details.notes.htm";
import productListTemplateUrl from "emun.cust/details/cust-details.product-list.htm";
import placementsTemplateUrl from "emun.cust/details/cust-details.placements.htm";
import commitmentsTemplateUrl from "emun.cust/details/cust-details.commitments.htm";
import interestsTemplateUrl from "emun.cust/details/cust-details.interests.htm";

import getOrderStates from "emun.order/order.states";
import { getInvStates } from "emun.invoice/inv/inv.states";

export const overview = {
  title: `Overview`,
  templateUrl: overviewTemplateUrl,
};
export const profile = {
  title: `Profile`,
  templateUrl: profileTemplateUrl,
};
export const shipTo = {
  title: `Ship To`,
  templateUrl: shipToTemplateUrl,
};
export const paymentMethods = {
  title: `Payment Methods`,
  templateUrl: paymentMethodsTemplateUrl,
};
export const vendorInfo = {
  title: `Vendor Information`,
  templateUrl: vendorInfoTemplateUrl,
  authorize: ($session) => $session.isVendor(),
};
export const orders = {
  title: `Orders`,
  templateUrl: ordersTemplateUrl,
  authorize: ($session) => !$session.hasPermission('ViewOrderInvoiceHistory')
};
export const invoices = {
  title: `Invoices`,
  templateUrl: invoicesTemplateUrl,
  authorize: ($session) => !$session.hasPermission('ViewOrderInvoiceHistory')
};
export const documents = {
  title: `Documents`,
  templateUrl: documentsTemplateUrl,
};
export const paymentHistory = {
  title: `Payment History`,
  templateUrl: paymentHistoryTemplateUrl,
  authorize: ($session) => !$session.isCorpOrAbove(),
};
export const itemHistory = {
  title: `Item History`,
  templateUrl: itemHistoryTemplateUrl,
};
export const purchaseHistory = {
  title: `Purchase History`,
  templateUrl: purchaseHistoryTemplateUrl,
};
export const topSellers = {
  title: `Top Sellers`,
  templateUrl: topSellersTemplateUrl,
};
export const productList = {
  title: `My Products`,
  templateUrl: productListTemplateUrl,
};
export const placements = {
  title: `Product Placements`,
  templateUrl: placementsTemplateUrl,
};
export const payments = {
  title: `Payments`,
  templateUrl: paymentsTemplateUrl,
  authorize: ($session) => !$session.isCorpOrAbove(),
};
export const changeLog = {
  title: `Change Log`,
  templateUrl: changeLogTemplateUrl,
  authorize: ($session) => !$session.isCorpOrAbove(),
};
export const forms = {
  title: `Forms`,
  templateUrl: formsTemplateUrl,
};
export const users = {
  title: `Users`,
  templateUrl: usersTemplateUrl,
};
export const creditmemos = {
  title: `Credit Memos`,
  templateUrl: creditmemosTemplateUrl,
};
export const contacts = {
  title: `Contacts`,
  templateUrl: contactsTemplateUrl,
};
export const activities = {
  title: `Activities`,
  templateUrl: activitiesTemplateUrl,
};
export const notes = {
  title: `Notes`,
  templateUrl: notesTemplateUrl,
  authorize: ($session) => $session.isRetailer()
};
export const commitments = {
  title: `Commitments`,
  templateUrl: commitmentsTemplateUrl,
};
export const interests = {
  title: `Interests`,
  templateUrl: interestsTemplateUrl,
};

export default {
  overview,
  profile,
  contacts,
  activities,
  notes,
  shipTo,
  paymentMethods,
  vendorInfo,
  orders: getOrderStates,
  invoices: getInvStates,
  itemHistory,
  purchaseHistory,
  topSellers,
  productList,
  placements,
  creditmemos: (args) => getInvStates({ ...args, mode: "creditmemo", title: 'Credit Memos' }),
  documents,
  paymentHistory,
  changeLog,
  forms,
  users,
  payments,
  commitments,
  interests
};
